import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled(GridWrapper)`
	border-bottom: 1px ${palette('gray2')} solid;
	grid-template-columns: 100%;
	padding-bottom: 96px;

	${minWidth('tablet')} {
		grid-template-columns: 50% 50%;
	}
`;

export const Column = styled.div``;

export const Photo = styled.div`
	aspect-ratio: 1.32;
	margin-bottom: 24px;
	position: relative;
	width: 100%;
`;

export const Heading = styled.h2`
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 24px;
	position: relative;
	width: 80%;
`;

export const Copy = styled.p`
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 24px;

	${minWidth('tablet')} {
		margin-bottom: 36px;
	}

	${minWidth('desktop')} {
		margin-bottom: 24px;
	}
`;
